<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('designfile_edit')">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-cad</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-designfile-show">
      <v-row>
        <v-col md="4">
          <STLView
              class="ml-4"
              ref="viewSTL"
              :item="item"
              v-if="item['file']"
          />
        </v-col>
        <v-col md="8">
          <v-simple-table>
            <template slot="default">
              <thead>
              <tr>
                <th>{{ $t('global.field') }}</th>
                <th>{{ $t('global.value') }}</th>
                <th>{{ $t('global.field') }}</th>
                <th>{{ $t('global.value') }}</th>
              </tr>
              </thead>

              <tbody>
              <tr>

                <td><strong>{{ $t('global.name') }}</strong></td>
                <td>
                  {{ item['name'] }}
                </td>
                <td><strong>{{ $t('designfile.stl') }}</strong></td>
                <td>
                  <v-btn
                      v-if="item['file']"
                      color="secondary"
                      class=""
                      @click="downloadFile(item['original_name'])"
                  >
                    {{ $t('global.download') }}
                    <v-icon
                        right
                        dark
                    >mdi-download
                    </v-icon>
                  </v-btn>
                </td>
              </tr>

              <tr>
                <td><strong>{{ $t('designfile.type') }}</strong></td>
                <td>
                  <span v-if="item['type']">{{ item['type'].name }}</span>
                </td>

                <td><strong>{{ $t('designfile.customer') }}</strong></td>
                <td>
                  <span v-if="item['customer']">{{ item['customer'].name }}</span>
                </td>

              </tr>
              <tr>



                <td><strong>{{ $t('designfile.ref') }}</strong></td>
                <td>
                  {{ item['ref'] }}
                </td>
                <td></td>
                <td>
                </td>
              </tr>
              <tr>
                  <td><strong>{{$t('designfile.nda')}}</strong></td>

                  <td :class="colorBoolean(item.nda)">
                    {{item.nda}}
                  </td>

                <td><strong>{{ $t('designfile.tags') }}</strong></td>
                <td>
                  <div id="tags" >
                    <v-chip v-for="tag in item['tags']" :key="tag.id"
                            class="ma-1 font-weight-bold"

                            color="accent"
                    >
                      {{ tag.name }}
                    </v-chip>
                  </div>
                </td>



              </tr>
              <tr>
                <td ><strong>{{ $t('designfile.comment') }}</strong></td>
                <td  colspan="3">
                  {{ item['comment'] }}
                </td>


              </tr>
              <tr>
                <td><strong>{{ $t('global.createdat') }}</strong></td>
                <td>
                  {{ formatDateTime(item['created'], 'long') }}              </td>
                <td><strong>{{ $t('global.createdby') }}</strong></td>
                <td>
                  <span v-if="item['createdBy']">{{ item['createdBy'].login }}</span>
                </td>

              </tr>
              <tr>
                <td><strong>{{ $t('global.updatedat') }}</strong></td>
                <td>
                  {{ formatDateTime(item['updated'], 'long') }}              </td>
                <td><strong>{{ $t('global.updatedby') }}</strong></td>
                <td>
                  <span v-if="item['updatedBy']">{{ item['updatedBy'].login }}</span>
                </td>
              </tr>


              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>

      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <OrderList
                ref="OrderListDesignFile"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <ProdFileList
                ref="ProdFileListDesignFile"
                :designFileParent="item"
            />
          </v-col>
        </v-row>
      </v-container>

    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';
import OrderList from '../order/ListSub';
import ProdFileList from '../prodfile/ListSub';
import STLView from '../../components/STLView.vue';

const servicePrefix = 'DesignFile';

export default {
  name: 'DesignFileShow',
  servicePrefix,
  components: {
    Loading,
    Toolbar,
    OrderList,
    ProdFileList,
    STLView,
  },
  data() {
    return {
    };
  },

  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('designfile', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('designfile', ['find']),

  },
  methods: {
    colorBoolean(bool) {
      if (bool) return 'green--text'
      else return 'red--text'
    },
    ...mapActions('designfile', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

  },
};
</script>
